var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConsultantFound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 156C121.078 156 156 121.078 156 78C156 34.9218 121.078 0 78 0C34.9218 0 0 34.9218 0 78C0 121.078 34.9218 156 78 156Z",
    fill: "black",
    fillOpacity: 0.03
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1068_18179",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 156,
    height: 156
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78 156C121.078 156 156 121.078 156 78C156 34.9218 121.078 0 78 0C34.9218 0 0 34.9218 0 78C0 121.078 34.9218 156 78 156Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1068_18179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.548 158.223L129.331 139.016C129.069 115.784 123.222 103.098 115.572 95.8476C107.614 87.3173 93.7592 84.4418 77.9836 84.4418C62.2081 84.4418 48.3559 87.3283 40.398 95.8476C32.7592 103.101 26.9146 115.784 26.6394 139.016L26.4551 158.223H129.548Z",
    fill: "#0A882F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.651 88.1428H66.3523V158.232H89.651V88.1428Z",
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0003 102.014C81.0898 102.014 84.0528 100.787 86.2376 98.6027C88.4225 96.4184 89.6503 93.4557 89.651 90.3662V68.5451H66.3523V90.3662C66.3523 91.8958 66.6536 93.4105 67.2389 94.8237C67.8243 96.2369 68.6823 97.521 69.7639 98.6026C70.8455 99.6842 72.1296 100.542 73.5428 101.128C74.956 101.713 76.4706 102.014 78.0003 102.014Z",
    fill: "#D99068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1454 22.4155C98.1454 19.9817 97.4235 17.6026 96.0712 15.5792C94.7188 13.5557 92.7967 11.9789 90.548 11.048C88.2993 10.1171 85.8251 9.87415 83.4382 10.3498C81.0514 10.8254 78.8593 11.9982 77.1391 13.7199C75.4189 15.4416 74.2481 17.6348 73.7746 20.022C73.3011 22.4093 73.5464 24.8833 74.4792 27.1312C75.4121 29.3791 76.9907 31.2998 79.0153 32.6503C81.04 34.0008 83.4197 34.7205 85.8535 34.7184C89.1164 34.7184 92.2457 33.4222 94.5529 31.1149C96.8602 28.8077 98.1564 25.6784 98.1564 22.4155",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8577 43.378V59.2554C57.8577 70.5374 67.0979 84.9261 78.3909 84.7115C89.3345 84.5051 98.1455 70.6475 98.1455 59.6516V43.378C98.1455 38.0351 96.023 32.9111 92.2451 29.1331C88.4671 25.3552 83.343 23.2327 78.0002 23.2327C72.6578 23.2335 67.5345 25.3562 63.7571 29.1341C59.9797 32.912 57.8577 38.0356 57.8577 43.378Z",
    fill: "#E2A88A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1913 29.9166C92.3407 27.4179 89.9369 25.3814 87.1681 23.9665C84.3993 22.5515 81.3406 21.7965 78.2314 21.7606C67.0237 21.6312 57.855 31.0641 57.855 42.2691V47.5221C68.2292 46.418 77.9732 42.0062 85.6473 34.9385L85.9554 34.6633L98.151 48.653V41.9113C98.1578 37.5909 96.769 33.3839 94.1913 29.9166Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.37 119.438C115.022 115.448 109.048 115.839 107.427 120.338C105.575 115.69 99.835 115.448 98.4867 119.438C96.0624 126.609 107.427 133.472 107.427 133.472C107.427 133.472 118.794 126.609 116.37 119.438Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConsultantFound);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/consultant-found.2b19fa1d7b938ff400d3e8064b213a88.svg";